import { WithPagination } from '@bv/api/crud';

class CallCenterPhoneNumbersApi extends WithPagination<CallCenterPhoneNumber> {
  public constructor(public endpoint = 'conversations/channels/voip-phone-numbers/all') {
    super(endpoint);
  }
}

export const callCenterPhoneNumbersApi = new CallCenterPhoneNumbersApi();
